import { createContext, useContext } from "react";

export const DesktopContext = createContext({});

export const useDesktop = () => {
    const desktop = useContext(DesktopContext);
    return desktop;
};

export const PanelContext = createContext({});

export const usePanel = () => {
    const panel = useContext(PanelContext);
    return panel;
}